export enum UploadDocType {
    Ratings = 1,
    Questions = 2,
    Employees = 3,
    KPI = 4
}